import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Animal } from './../animal';
import { Animalagility } from './../animalagility';
import { Animalshow } from './../animalshow';
import { Animallitter } from './../animallitter';
import { Animallitterpuppy } from './../animallitterpuppy';
import { FileUploadService } from './../file-upload.service';
import { Globals } from './../globals';

interface AnimalExtended extends Animal {
  activeSheet: number;
  agilityShows: AnimalAgilityExtended[];
  Shows: AnimalShowExtended[];
  Litters: AnimalLitterExtended[];
  images: string[];
}

interface AnimalAgilityExtended extends Animalagility {
  images: string[];
}

interface AnimalShowExtended extends Animalshow {
  images: string[];
}

interface AnimalLitterExtended extends Animallitter {
  puppies: AnimallitterpuppyExtended[];
}

interface AnimallitterpuppyExtended extends Animallitterpuppy {
  images: string[];
}

@Component({
  selector: 'app-dogs',
  templateUrl: './dogs.component.html',
  styleUrls: ['./dogs.component.css']
})

export class DogsComponent implements OnInit {
  animals: AnimalExtended[];
  currentAgilytyShow: AnimalAgilityExtended;
  currentShow: AnimalShowExtended;
  currentLitter: AnimalLitterExtended;
  currentPuppy: AnimallitterpuppyExtended;
  currentAnimal: AnimalExtended;
  currentImage: string;
  loadingTxt: string;
  loading: boolean;
  loadingOk: number;
  @ViewChild('fileInput') fileInput;
  @ViewChild('fileShowInput') fileShowInput;
  @ViewChild('filePuppyInput') filePuppyInput;
  @ViewChild('fileAnimalInput') fileAnimalInput;
  @ViewChild('fileDogInput') fileDogInput;

  constructor(private httpClient: HttpClient, private fileUploadService: FileUploadService, private globals: Globals) { }

  ngOnInit() {
    this.loadingTxt = '';
    this.loading = false;
    this.loadingOk = 0;
    this.animals = [];
    this.getDogs();
    this.currentAgilytyShow = { id: 0, animalid: 0, town: '', agilitydate: new Date(), review: '', images: [] };
    this.currentShow = { id: 0, animalid: 0, town: '', showdate: new Date(), judge: '', review: '', rating: '', images: [] };
    this.currentLitter = { id: 0, animalid: 0, litterdate: new Date(), description: '', puppies: [] };
    this.currentPuppy = { id: 0, animalid: 0, litterid: 0, fullname: '', images: [] };
    this.currentAnimal = {
      id: 0,
      fullname: '',
      breed: '',
      gender: '',
      regnumber: '',
      dateofbirth: new Date(),
      hair: '',
      colour: '',
      height: 0,
      weight: 0,
      breeder: '',
      owner: '',
      healt: '',
      story: '',
      dogimage: '',
      activeSheet: 0,
      agilityShows: [],
      Shows: [],
      Litters: [],
      images: []
    };
    this.currentImage = '';
  }

  createDog($event) {
    this.currentAnimal = {
      id: 0,
      fullname: '',
      breed: '',
      gender: '',
      regnumber: '',
      dateofbirth: new Date(),
      hair: '',
      colour: '',
      height: 0,
      weight: 0,
      breeder: '',
      owner: '',
      healt: '',
      story: '',
      dogimage: '',
      activeSheet: 0,
      agilityShows: [],
      Shows: [],
      Litters: [],
      images: []
    };
  }

  updateDog($event) {
    const animal = {
      id: this.currentAnimal.id,
      fullname: this.currentAnimal.fullname,
      breed: this.currentAnimal.breed,
      gender: this.currentAnimal.gender,
      regnumber: this.currentAnimal.regnumber,
      dateofbirth: this.currentAnimal.dateofbirth,
      hair: this.currentAnimal.hair,
      colour: this.currentAnimal.colour,
      height: this.currentAnimal.height,
      weight: this.currentAnimal.weight,
      breeder: this.currentAnimal.breeder,
      owner: this.currentAnimal.owner,
      healt: this.currentAnimal.healt,
      story: this.currentAnimal.story,
      dogimage: this.currentAnimal.dogimage
    };

    if (this.currentAnimal.id === 0) {
      this.httpClient.post('https://www.saaristonsiirin.com/api/insert.php/animals',
      JSON.stringify(animal)).subscribe(() => {
        this.getDogs();
      });
    } else {
      this.httpClient.post('https://www.saaristonsiirin.com/api/update.php/animals/' + this.currentAnimal.id,
      JSON.stringify(animal)).subscribe(() => {
        this.getDogs();
      });
    }
  }

  showImageButtonDog() {
    return this.currentAnimal.id > 0;
  }

  editDog($event, animal: AnimalExtended) {
    this.currentAnimal = animal;
  }

  uploadDogImage() {
    this.loadingTxt = 'Lähetän tiedostoa...';
    this.loading = true;
    this.loadingOk = 0;
    const fileBrowser = this.fileDogInput.nativeElement;
    if (fileBrowser.files && fileBrowser.files[0]) {
      const formData = new FormData();
      formData.append('image', fileBrowser.files[0]);
      this.httpClient.get('https://www.saaristonsiirin.com/api/deleteDirectory.php/dogs/' + this.currentAnimal.id).subscribe(() => {
        this.fileUploadService.uploadDog(formData, this.currentAnimal.id).subscribe((res) => {
          this.loadingOk = res[0];
          this.loadingTxt = res[1];
          this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/dogs/' + this.currentAnimal.id)
          .subscribe(imagedata => {
            this.currentAnimal.dogimage = imagedata[0];
          });
          this.loading = false;
        });
      });
    }
  }

  deleteDog($event, animal: AnimalExtended) {
    if (confirm('Oletko varama että haluat poistaa  ' + animal.fullname + '?')) {
    this.httpClient.get('https://www.saaristonsiirin.com/api/delete.php/animals/' + animal.id).subscribe(() => {
      this.httpClient.get('https://www.saaristonsiirin.com/api/deleteDirectory.php/animals/' + animal.id).subscribe(() => {
        animal.agilityShows.forEach(agilityShow => {
          this.httpClient.get('https://www.saaristonsiirin.com/api/delete.php/animalagility/' + agilityShow.id).subscribe();
          this.httpClient.get('https://www.saaristonsiirin.com/api/deleteDirectory.php/agility/' + agilityShow.id).subscribe();
        });
        animal.Shows.forEach(Show => {
          this.httpClient.get('https://www.saaristonsiirin.com/api/delete.php/animalshows/' + Show.id).subscribe();
          this.httpClient.get('https://www.saaristonsiirin.com/api/deleteDirectory.php/shows/' + Show.id).subscribe();
        });
        animal.Litters.forEach(Litter => {
          this.httpClient.get('https://www.saaristonsiirin.com/api/delete.php/animallitter/' + Litter.id).subscribe();
        });
        this.httpClient.get('https://www.saaristonsiirin.com/api/deleteDirectory.php/animals/' + animal.id).subscribe();
        this.httpClient.get('https://www.saaristonsiirin.com/api/deleteDirectory.php/dogs/' + animal.id).subscribe();
      });
    });
    this.getDogs();
  }
  }

  getDogs() {
    let animalExtended: AnimalExtended;
    this.httpClient.get<Animal[]>('https://www.saaristonsiirin.com/api/getDogs.php').subscribe(data => {
    this.animals = [];
    data.forEach(animal => {
        animalExtended = {
          id: animal.id,
          fullname: animal.fullname,
          breed: animal.breed,
          gender: animal.gender,
          regnumber: animal.regnumber,
          dateofbirth: animal.dateofbirth,
          hair: animal.hair,
          colour: animal.colour,
          height: animal.height,
          weight: animal.weight,
          breeder: animal.breeder,
          owner: animal.owner,
          healt: animal.healt,
          story: animal.story,
          dogimage: animal.dogimage,
          activeSheet: 0,
          agilityShows: [],
          Shows: [],
          Litters: [],
          images: []
        };
        this.animals.push(animalExtended);
      });
    });
  }

  changeActiveSheet(animal: AnimalExtended, toSheet: number) {
    this.loadingTxt = '';
    switch (toSheet) {
        case 1: // Agilityshow haku
        this.httpClient.get<Animalagility[]>('https://www.saaristonsiirin.com/api/getAgility.php/' + animal.id)
        .subscribe((data) => {
          let agilityShowExtended: AnimalAgilityExtended;
          animal.agilityShows = [];
          data.forEach(agilityShow => {
            agilityShowExtended = {
            id: agilityShow.id,
            animalid: agilityShow.animalid,
            town: agilityShow.town,
            agilitydate: agilityShow.agilitydate,
            review: agilityShow.review,
            images: []
            };
            animal.agilityShows.push(agilityShowExtended);
          });

          animal.agilityShows.forEach(agilityShow => {
            this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/agility/' + agilityShow.id)
            .subscribe(imagedata => {
              agilityShow.images = imagedata;
            });
          });
        });
        break;
        case 2: // näyttelyshow haku
        this.httpClient.get<Animalshow[]>('https://www.saaristonsiirin.com/api/getShow.php/' + animal.id)
        .subscribe((data) => {
          let showExtended: AnimalShowExtended;
          animal.Shows = [];
          data.forEach(show => {
            showExtended = {
            id: show.id,
            animalid: show.animalid,
            town: show.town,
            showdate: show.showdate,
            judge: show.judge,
            review: show.review,
            rating: show.rating,
            images: []
            };
            animal.Shows.push(showExtended);
          });

          animal.Shows.forEach(Show => {
            this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/shows/' + Show.id)
            .subscribe(imagedata => {
              Show.images = imagedata;
            });
          });
        });
        break;
        case 3: // pennut haku
        this.httpClient.get<Animallitter[]>('https://www.saaristonsiirin.com/api/getLitter.php/' + animal.id)
        .subscribe((data) => {
          let litterExtended: AnimalLitterExtended;
          animal.Litters = [];
          data.forEach(litter => {
            litterExtended = {
              id: litter.id,
              animalid: litter.animalid,
              description: litter.description,
              litterdate: litter.litterdate,
              puppies: []
            };
            animal.Litters.push(litterExtended);
          });

          this.setPuppies(animal);
        });
        break;
        case 4:
        this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/animals/' + animal.id)
        .subscribe(imagedata => {
          animal.images = imagedata;
        });
        break;
    }
    animal.activeSheet = toSheet;
  }

  setPuppies(animal: AnimalExtended) {
    this.httpClient.get<Animallitterpuppy[]>('https://www.saaristonsiirin.com/api/get.php/animallitterpuppy')
    .subscribe((data) => {
    let puppy: AnimallitterpuppyExtended;
    let i: number;
    data.forEach(p => {
      puppy = {
      id: p.id,
      animalid: p.animalid,
      litterid: p.litterid,
      fullname: p.fullname,
      images: []
      };

      // Haetaan pentue
      i = animal.Litters.findIndex(o => o.id === puppy.litterid);

      // Lisätään pentue
      if (i >= 0) {
        animal.Litters[i].puppies.push(puppy);
      }
    });

    this.setPuppyImages(animal);
  });
  }

  setPuppyImages(animal: AnimalExtended) {
    animal.Litters.forEach(litter => {
      litter.puppies.forEach(puppy => {
        this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/puppies/' + puppy.id)
        .subscribe(imagedata => {
          puppy.images = imagedata;
        });
      });
    });
  }

  previewAnimalImage($event, animal: AnimalExtended, imageFile: string) {
    const modal = document.getElementById('previewModal');
    const modalImg = <HTMLImageElement>document.getElementById('imgPreview');
    modal.style.display = 'block';
    modalImg.src = 'https://www.saaristonsiirin.com/api/uploads/animals/' + animal.id + '/' + imageFile;
    this.currentAnimal = animal;
    this.currentImage = imageFile;
  }

  nextPreview() {
    const modalImg = <HTMLImageElement>document.getElementById('imgPreview');
    const currentIndex = this.currentAnimal.images.findIndex(data => data === this.currentImage);

    if (currentIndex === this.currentAnimal.images.length - 1) {
      this.currentImage = this.currentAnimal.images[0];
    } else {
      this.currentImage = this.currentAnimal.images[currentIndex + 1];
    }

    modalImg.src = 'https://www.saaristonsiirin.com/api/uploads/animals/' +
    this.currentAnimal.id + '/' +
    this.currentImage;
  }

  previousPreview() {
    const modalImg = <HTMLImageElement>document.getElementById('imgPreview');
    const currentIndex = this.currentAnimal.images.findIndex(data => data === this.currentImage);

    if (currentIndex === 0) {
      this.currentImage = this.currentAnimal.images[this.currentAnimal.images.length - 1];
    } else {
      this.currentImage = this.currentAnimal.images[currentIndex - 1];
    }

    modalImg.src = 'https://www.saaristonsiirin.com/api/uploads/animals/' +
    this.currentAnimal.id + '/' +
    this.currentImage;
  }

  closePreview() {
    const modal = document.getElementById('previewModal');
    modal.style.display = 'none';
  }

  uploadAnimalImage(animal: AnimalExtended) {
    this.loadingTxt = 'Lähetän tiedostoa...';
    this.loading = true;
    this.loadingOk = 0;
    const fileBrowser = this.fileAnimalInput.nativeElement;
    if (fileBrowser.files && fileBrowser.files[0]) {
      const formData = new FormData();
      formData.append('image', fileBrowser.files[0]);
      this.fileUploadService.uploadAnimal(formData, animal.id).subscribe(res => {
        this.loadingOk = res[0];
        this.loadingTxt = res[1];
        this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/animals/' + animal.id)
        .subscribe(imagedata => {
          animal.images = imagedata;
        });
      });
    }
  }

  deleteAnimalImage($event, animal: AnimalExtended, dogImage: string) {
    this.httpClient.get('https://www.saaristonsiirin.com/api/deleteFile.php/animals/' + animal.id + '/' + dogImage)
    .subscribe(() => {
      this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/animals/' + animal.id)
      .subscribe(imagedata => {
        animal.images = imagedata;
      });
    });
  }

  showImageButton() {
    return this.currentAgilytyShow.id > 0;
  }

  uploadAgilityImage() {
    this.loadingTxt = 'Lähetän tiedostoa...';
    this.loading = true;
    this.loadingOk = 0;
    const fileBrowser = this.fileInput.nativeElement;
    if (fileBrowser.files && fileBrowser.files[0]) {
      const formData = new FormData();
      formData.append('image', fileBrowser.files[0]);
      this.fileUploadService.uploadagility(formData, this.currentAgilytyShow.id).subscribe(res => {
        this.loadingOk = res[0];
        this.loadingTxt = res[1];
        this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/agility/' + this.currentAgilytyShow.id)
        .subscribe(imagedata => {
          this.currentAgilytyShow.images = imagedata;
        });
      });
    }
  }

  deleteAgilityImage($event, agilityImage: string) {
    this.httpClient.get('https://www.saaristonsiirin.com/api/deleteFile.php/agility/' + this.currentAgilytyShow.id + '/' + agilityImage)
    .subscribe(() => {
      this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/agility/' + this.currentAgilytyShow.id)
      .subscribe(imagedata => {
        this.currentAgilytyShow.images = imagedata;
      });
    });
  }

  createAgilityShow(animal: AnimalExtended) {
    this.currentAgilytyShow = { id: 0, animalid: animal.id, town: '', agilitydate: new Date(), review: '', images: [] };
  }

  editAgilityShow($event, agilityShow: AnimalAgilityExtended) {
    this.currentAgilytyShow = agilityShow;
  }

  deleteAgilityShow($event, agilityShow: AnimalAgilityExtended) {
    if (confirm('Oletko varma että haluat poistaa tuloksen ' + agilityShow.review + '?')) {
    this.httpClient.get('https://www.saaristonsiirin.com/api/delete.php/animalagility/' + agilityShow.id).subscribe(() => {
      this.httpClient.get('https://www.saaristonsiirin.com/api/deleteDirectory.php/agility/' + agilityShow.id).subscribe(() => {
        for (let index = 0; index < this.animals.length; index++) {
          if (this.animals[index].id === agilityShow.animalid) {
            this.changeActiveSheet(this.animals[index], 1);
          }
        }
      });
    });
  }
  }

  updateAgilytyShow($event) {
    const agilityShow = {
      id: this.currentAgilytyShow.id,
      animalid: this.currentAgilytyShow.animalid,
      town: this.currentAgilytyShow.town,
      agilitydate: this.currentAgilytyShow.agilitydate,
      review: this.currentAgilytyShow.review,
    };

    if (this.currentAgilytyShow.id === 0) {
      this.httpClient.post('https://www.saaristonsiirin.com/api/insert.php/animalagility',
      JSON.stringify(agilityShow)).subscribe(() => {
        for (let index = 0; index < this.animals.length; index++) {
          if (this.animals[index].id === agilityShow.animalid) {
            this.changeActiveSheet(this.animals[index], 1);
          }
        }
      });
    } else {
      this.httpClient.post('https://www.saaristonsiirin.com/api/update.php/animalagility/' + this.currentAgilytyShow.id,
      JSON.stringify(agilityShow)).subscribe(() => {
        for (let index = 0; index < this.animals.length; index++) {
          if (this.animals[index].id === agilityShow.animalid) {
            this.changeActiveSheet(this.animals[index], 1);
          }
        }
      });
    }
  }

  showImageButton2() {
    return this.currentShow.id > 0;
  }

  uploadShowImage() {
    this.loadingTxt = 'Lähetän tiedostoa...';
    this.loading = true;
    this.loadingOk = 0;
    const fileBrowser = this.fileShowInput.nativeElement;
    if (fileBrowser.files && fileBrowser.files[0]) {
      const formData = new FormData();
      formData.append('image', fileBrowser.files[0]);
      this.fileUploadService.uploadshow(formData, this.currentShow.id).subscribe(res => {
        this.loadingOk = res[0];
        this.loadingTxt = res[1];
        this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/shows/' + this.currentShow.id)
        .subscribe(imagedata => {
          this.currentShow.images = imagedata;
        });
      });
    }
  }

  deleteShowImage($event, showImage: string) {
    this.httpClient.get('https://www.saaristonsiirin.com/api/deleteFile.php/shows/' + this.currentShow.id + '/' + showImage)
    .subscribe(() => {
      this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/shows/' + this.currentShow.id)
      .subscribe(imagedata => {
        this.currentShow.images = imagedata;
      });
    });
  }

  createShow(animal: AnimalExtended) {
    this.currentShow = { id: 0, animalid: animal.id, town: '', showdate: new Date(), judge: '', review: '', rating: '', images: [] };
  }

  editShow($event, Show: AnimalShowExtended) {
    this.currentShow = Show;
  }

  deleteShow($event, Show: AnimalShowExtended) {
    if (confirm('Oletko varma että haluat poistaa tuloksen ' + Show.review + '?')) {
    this.httpClient.get('https://www.saaristonsiirin.com/api/delete.php/animalshows/' + Show.id).subscribe(() => {
      this.httpClient.get('https://www.saaristonsiirin.com/api/deleteDirectory.php/shows/' + Show.id).subscribe(() => {
        for (let index = 0; index < this.animals.length; index++) {
          if (this.animals[index].id === Show.animalid) {
            this.changeActiveSheet(this.animals[index], 2);
          }
        }
      });
    });
  }
  }

  updateShow($event) {
    const Show = {
      id: this.currentShow.id,
      animalid: this.currentShow.animalid,
      town: this.currentShow.town,
      judge: this.currentShow.judge,
      showdate: this.currentShow.showdate,
      review: this.currentShow.review,
      rating: this.currentShow.rating
    };

    if (this.currentShow.id === 0) {
      this.httpClient.post('https://www.saaristonsiirin.com/api/insert.php/animalshows',
      JSON.stringify(Show)).subscribe(() => {
        for (let index = 0; index < this.animals.length; index++) {
          if (this.animals[index].id === Show.animalid) {
            this.changeActiveSheet(this.animals[index], 2);
          }
        }
      });
    } else {
      this.httpClient.post('https://www.saaristonsiirin.com/api/update.php/animalshows/' + this.currentShow.id,
      JSON.stringify(Show)).subscribe(() => {
        for (let index = 0; index < this.animals.length; index++) {
          if (this.animals[index].id === Show.animalid) {
            this.changeActiveSheet(this.animals[index], 2);
          }
        }
      });
    }
  }

  createLitter(animal: AnimalExtended) {
    this.currentLitter = { id: 0, animalid: animal.id, litterdate: new Date(), description: '', puppies: [] };
  }

  editLitter($event, Litter: AnimalLitterExtended) {
    this.currentLitter = Litter;
  }

  deleteLitter($event, Litter: AnimalLitterExtended) {
    if (confirm('Oletko varma että haluat poistaa pentueen ' + Litter.description + '?')) {
    this.httpClient.get('https://www.saaristonsiirin.com/api/delete.php/animallitter/' + Litter.id).subscribe(() => {
        for (let index = 0; index < this.animals.length; index++) {
          if (this.animals[index].id === Litter.animalid) {
            this.changeActiveSheet(this.animals[index], 3);
          }
        }
    });
  }
  }

  updateLitter($event) {
    let litter: Animallitter;

litter = {
  id: this.currentLitter.id,
  animalid: this.currentLitter.animalid,
  litterdate: this.currentLitter.litterdate,
  description: this.currentLitter.description
};
    if (litter.id === 0) {
      this.httpClient.post('https://www.saaristonsiirin.com/api/insert.php/animallitter',
      JSON.stringify(litter)).subscribe(() => {
        for (let index = 0; index < this.animals.length; index++) {
          if (this.animals[index].id === litter.animalid) {
            this.changeActiveSheet(this.animals[index], 3);
          }
        }
      });
    } else {
      this.httpClient.post('https://www.saaristonsiirin.com/api/update.php/animallitter/' + litter.id,
      JSON.stringify(litter)).subscribe(() => {
        for (let index = 0; index < this.animals.length; index++) {
          if (this.animals[index].id === litter.animalid) {
            this.changeActiveSheet(this.animals[index], 3);
          }
        }
      });
    }
  }

  showImageButton3() {
    return this.currentPuppy.id > 0;
  }

  uploadPuppyImage() {
    this.loadingTxt = 'Lähetän tiedostoa...';
    this.loading = true;
    this.loadingOk = 0;
    const fileBrowser = this.filePuppyInput.nativeElement;
    if (fileBrowser.files && fileBrowser.files[0]) {
      const formData = new FormData();
      formData.append('image', fileBrowser.files[0]);
      this.fileUploadService.uploadPuppy(formData, this.currentPuppy.id).subscribe(res => {
        this.loadingOk = res[0];
        this.loadingTxt = res[1];
        this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/puppies/' + this.currentPuppy.id)
        .subscribe(imagedata => {
          this.currentPuppy.images = imagedata;
        });
      });
    }
  }

  deletePuppyImage($event, PuppyImage: string) {
    this.httpClient.get('https://www.saaristonsiirin.com/api/deleteFile.php/puppies/' + this.currentPuppy.id + '/' + PuppyImage)
    .subscribe(() => {
      this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/puppies/' + this.currentPuppy.id)
      .subscribe(imagedata => {
        this.currentPuppy.images = imagedata;
      });
    });
  }

  createPuppy(animal: AnimalExtended, litter: Animallitter) {
    this.currentPuppy = { id: 0, animalid: animal.id, litterid: litter.id, fullname: '', images: [] };
  }

  editPuppy($event, Puppy: AnimallitterpuppyExtended) {
    this.currentPuppy = Puppy;
  }

  deletePuppy($event, Puppy: AnimallitterpuppyExtended) {
    if (confirm('Oletko varma että haluat poistaa pennun ' + Puppy.fullname + '?')) {
    this.httpClient.get('https://www.saaristonsiirin.com/api/delete.php/animallitterpuppy/' + Puppy.id).subscribe(() => {
      this.httpClient.get('https://www.saaristonsiirin.com/api/deleteDirectory.php/puppies/' + Puppy.id).subscribe(() => {
        for (let index = 0; index < this.animals.length; index++) {
          if (this.animals[index].id === Puppy.animalid) {
            this.changeActiveSheet(this.animals[index], 3);
          }
        }
      });
    });
  }
  }

  updatePuppy($event) {
    const Puppy = {
      id: this.currentPuppy.id,
      animalid: this.currentPuppy.animalid,
      litterid: this.currentPuppy.litterid,
      fullname: this.currentPuppy.fullname
    };

    if (this.currentPuppy.id === 0) {
      this.httpClient.post('https://www.saaristonsiirin.com/api/insert.php/animallitterpuppy',
      JSON.stringify(Puppy)).subscribe(() => {
        for (let index = 0; index < this.animals.length; index++) {
          if (this.animals[index].id === Puppy.animalid) {
            this.changeActiveSheet(this.animals[index], 3);
          }
        }
      });
    } else {
      this.httpClient.post('https://www.saaristonsiirin.com/api/update.php/animallitterpuppy/' + this.currentPuppy.id,
      JSON.stringify(Puppy)).subscribe(() => {
        for (let index = 0; index < this.animals.length; index++) {
          if (this.animals[index].id === Puppy.animalid) {
            this.changeActiveSheet(this.animals[index], 3);
          }
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/DEV/saaristonsiirin/src/app/dogs/dogs.component.ts